import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

// Explorer
export const getExplorerStats = () => api.get("/explorer/stats").then(r => r.data);
export const getLatestBlocks = (count = 10) => api.get(`/explorer/latest-blocks?count=${count}`).then(r => r.data);
export const getLatestTxs = (count = 10) => api.get(`/explorer/latest-txs?count=${count}`).then(r => r.data);
export const getBlockDetail = (number) => api.get(`/explorer/block/${number}`).then(r => r.data);
export const getTxDetail = (hash) => api.get(`/explorer/tx/${hash}`).then(r => r.data);
export const getAddressDetail = (address) => api.get(`/explorer/address/${address}`).then(r => r.data);

// Network
export const getNetworkConfig = () => api.get("/network/config").then(r => r.data);
export const getNetworkStatus = () => api.get("/network/status").then(r => r.data);
export const getRpcUptime = () => api.get("/network/uptime").then(r => r.data);
export const getRpcIncidents = () => api.get("/network/incidents").then(r => r.data);
export const getAdminActivity = (type) => api.get("/admin/activity", { params: type ? { type } : {}, withCredentials: true }).then(r => r.data);

// Wallet
export const getWalletBalances = (address) => api.get(`/wallet/balances/${address}`).then(r => r.data);

// Tokens
export const getToken = (address, holder) => api.get(`/tokens/${address}`, { params: holder ? { holder } : {} }).then(r => r.data);

export const getTokenTransfers = (address, page = 1) => api.get(`/tokens/${address}/transfers`, { params: { page } }).then(r => r.data);
export const getContractSource = (address) => api.get(`/contracts/${address}/source`).then(r => r.data);
export const verifyContract = (address, body) => api.post(`/contracts/${address}/verify`, body, { timeout: 120000 }).then(r => r.data);

// Faucet
export const getFaucetStatus = () => api.get("/faucet/status").then(r => r.data);
export const getAddressHistory = (address, before) =>
  api.get(`/explorer/address/${address}/txs`, { params: before != null ? { before } : {} }).then(r => r.data);
export const requestFaucet = (address, token = "FMI") => api.post("/faucet/request", { address, token }).then(r => r.data);
export const getFaucetCooldown = (address) => api.get(`/faucet/cooldown/${address}`).then(r => r.data);

// Exchange
export const getQuote = (action, amount, fromToken, toToken) =>
  api.post("/exchange/quote", { action, amount, fromToken, toToken }).then(r => r.data);
export const getPrices = () => api.get("/exchange/prices").then(r => r.data);
export const getPriceHistory = (range) => api.get("/exchange/price-history", { params: { range } }).then(r => r.data);
export const getTreasuryStats = (range) => api.get("/treasury/stats", { params: { range } }).then(r => r.data);
export const getPoolLiquidity = (range) => api.get("/exchange/pool/liquidity", { params: { range } }).then(r => r.data);
export const getLatestTrades = (limit = 15) => api.get("/exchange/trades/latest", { params: { limit } }).then(r => r.data);
export const getPoolOverview = (page = 1) => api.get("/exchange/pool", { params: { page } }).then(r => r.data);

export default api;
